"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addVisitedVehicleId = exports.deleteVisitedVehicleIds = exports.setLastVisitedVehicleIds = exports.DELETE_LAST_VISITED_VEHICLE_IDS = exports.SET_LAST_VISITED_VEHICLE_IDS = exports.ADD_VISITED_VEHICLE_ID = exports.LAST_VISITED_VEHICLE_IDS = void 0;
exports.LAST_VISITED_VEHICLE_IDS = '[last visited Vehicle Ids]';
exports.ADD_VISITED_VEHICLE_ID = `${exports.LAST_VISITED_VEHICLE_IDS} ADD`;
exports.SET_LAST_VISITED_VEHICLE_IDS = `${exports.LAST_VISITED_VEHICLE_IDS} SET`;
exports.DELETE_LAST_VISITED_VEHICLE_IDS = `${exports.LAST_VISITED_VEHICLE_IDS} DELETE`;
const setLastVisitedVehicleIds = ({ vehicleIds }) => ({
    type: exports.SET_LAST_VISITED_VEHICLE_IDS,
    payload: vehicleIds,
    meta: { feature: exports.LAST_VISITED_VEHICLE_IDS },
});
exports.setLastVisitedVehicleIds = setLastVisitedVehicleIds;
const deleteVisitedVehicleIds = () => ({
    type: exports.DELETE_LAST_VISITED_VEHICLE_IDS,
    payload: [],
    meta: { feature: exports.LAST_VISITED_VEHICLE_IDS },
});
exports.deleteVisitedVehicleIds = deleteVisitedVehicleIds;
const addVisitedVehicleId = ({ vehicleId }) => ({
    type: exports.ADD_VISITED_VEHICLE_ID,
    payload: vehicleId,
    meta: { feature: exports.LAST_VISITED_VEHICLE_IDS },
});
exports.addVisitedVehicleId = addVisitedVehicleId;
//# sourceMappingURL=lastVisitedVehicleIds.js.map